import { render, staticRenderFns } from "./dataoverview.vue?vue&type=template&id=f73ae866&scoped=true"
import script from "./dataoverview.vue?vue&type=script&lang=js"
export * from "./dataoverview.vue?vue&type=script&lang=js"
import style0 from "./dataoverview.vue?vue&type=style&index=0&id=f73ae866&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73ae866",
  null
  
)

export default component.exports